<script>
import MixedGridFiltersSelected from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersSelected';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [MixedGridFiltersSelected],

  emits: ['removeFilter', 'removeAllFilters'],
};
</script>

<template>
  <div v-if="hasFilters" class="text-center pt-8" data-cy="mixed-grid-filters-selected">
    <template v-for="(groupedFilters, filterId) in activeFilters">
      <template v-if="isRange(filterId)">
        <div :key="filterId" class="tag tag--dark m-1 tag--removable" data-cy="mixed-grid-filters-selected-choice">
          {{ getFilterById(filterId).label }}
          <button
            type="button"
            class="button button--icon ico--small"
            :aria-label="$t('Search.RemoveFilter')"
            @click="$emit('removeFilter', filterId)"
          >
            <phx-icon icon="close" />
          </button>
        </div>
      </template>
      <div
        v-for="value in groupedFilters"
        v-else
        :key="value"
        class="tag tag--dark m-1 tag--removable"
        data-cy="mixed-grid-filters-selected-choice"
      >
        {{ getFilterItemFromIdAndValue(filters, filterId, value).label }}
        <button
          type="button"
          class="button button--icon ico--small"
          :aria-label="$t('Search.RemoveFilter')"
          @click="$emit('removeFilter', filterId, value)"
        >
          <phx-icon icon="close" />
        </button>
      </div>
    </template>

    <button
      type="button"
      class="button button--dark button--dark-on-dark py-3 m-1"
      :aria-label="$t('Search.ResetAll')"
      data-cy="clear-filters-btn"
      @click="$emit('removeAllFilters')"
    >
      {{ $t('Search.ResetAll') }}
    </button>
  </div>
</template>
